module.exports = __webpack_public_path__ + "img/28_28.3b76ac00.png";